/**
 * Remote access for the wiki page reference listing, shared through
 * `useModel('wikiPageContext')` and consumed by `pages/v2/Reference/WikiPageList`.
 *
 * Deliberately cache-free, unlike `influencerContext`: this backs a curation
 * screen where the list must reflect what the server currently holds, and where
 * the same record is rarely requested twice.
 *
 * Every call takes `success`/`failed` callbacks instead of returning a value,
 * passes `skipErrorHandler: true` so a failure does not raise a global toast on
 * a screen that renders its own empty/error state, and treats a transport error
 * and a `success: false` body identically.
 *
 * One of four near-identical siblings (home / wiki / social / alias); a change
 * to the shape here almost certainly belongs in the other three too.
 */
// import { useState } from 'react';
import {
  getV2WikiPagesByInfluencersCount,
  getV2WikiPages,
  countV2WikiPages,
  markWikiPageValidity,
} from '@/services/rest/api';

export default () => {
  const doGetWikiPagesByInfluencersCount = async (
    success: (wikiPages: DATA.WikiPage[]) => void,
    failed: () => void,
  ) => {
    try {
      const msg = await getV2WikiPagesByInfluencersCount({ skipErrorHandler: true });
      if (msg.success && msg.data) {
        success(msg.data);
      } else {
        failed();
      }
    } catch (error) {
      console.error('Error fetching wiki pages:', error);
      failed();
    }
  };

  const doGetWikiPages = async (
    success: (wikiPages: DATA.WikiPage[]) => void,
    failed: () => void,
    isInvalid?: boolean,
    lastId?: string,
  ) => {
    try {
      const msg = await getV2WikiPages(isInvalid, lastId, { skipErrorHandler: true });
      if (msg.success && msg.data) {
        success(msg.data);
      } else {
        failed();
      }
    } catch (error) {
      console.error('Error fetching wiki pages:', error);
      failed();
    }
  };

  const doCountWikiPages = async (
    success: (count: number) => void,
    failed: () => void,
    isInvalid?: boolean,
  ) => {
    try {
      const msg = await countV2WikiPages(isInvalid, { skipErrorHandler: true });
      if (msg.success && typeof msg.data === 'number') {
        success(msg.data);
      } else {
        failed();
      }
    } catch (error) {
      console.error('Error count wiki pages:', error);
      failed();
    }
  };

  const doMarkWikiPageValidity = async (
    success: (obj: { id: string; isInvalid: boolean }) => void,
    failed: () => void,
    id: string,
    isInvalid: boolean,
  ) => {
    try {
      const msg = await markWikiPageValidity(id, isInvalid, { skipErrorHandler: true });
      if (msg.success && msg.data) {
        success(msg.data);
      } else {
        failed();
      }
    } catch (error) {
      console.error('Error Mark wiki page validity:', error);
      failed();
    }
  };

  return {
    doGetWikiPagesByInfluencersCount,
    doGetWikiPages,
    doCountWikiPages,
    doMarkWikiPageValidity,
  };
};
